export default "ui-slideview-main{display:block;cursor:pointer}\n";